import { Box } from "@material-ui/core";
import glydeGif from "../../assets/icons/glyde-loading.gif";
import strings from "../../global/constants/StringConstants";
import { centerItemFlex } from "../../utils/styles";

const Loading = () => {
  return (
    <Box
      style={{
        height: "100vh",
        ...(centerItemFlex as React.CSSProperties),
      }}
    >
      <img
        src={glydeGif}
        alt={strings.glydeLoadingImage}
        style={{
          width: "50px",
          height: "50px",
        }}
      />
    </Box>
  );
};

export default Loading;
